(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/components/competition-subscriber-manager.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/components/competition-subscriber-manager.js');
"use strict";

const useTeamsIds = svs.components.marketplaceCompetition.services.hooks.useTeamsIds;
const _svs$components$marke = svs.components.marketplaceCompetition.services.components,
  CompetitionSubscriber = _svs$components$marke.CompetitionSubscriber,
  CompetitionSubscriberTeam = _svs$components$marke.CompetitionSubscriberTeam;
const CompetitionSubscriberManager = React.memo(_ref => {
  let competitionId = _ref.competitionId;
  const teamIds = useTeamsIds(competitionId);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionSubscriber, {
    competitionId: competitionId
  }), teamIds && teamIds.length > 0 && teamIds.map(teamId => React.createElement(CompetitionSubscriberTeam, {
    competitionId: competitionId,
    key: teamId,
    teamId: teamId
  })));
});
setGlobal('svs.components.marketplaceCompetition.services.components.CompetitionSubscriberManager', CompetitionSubscriberManager);

 })(window);